import en from './en/translation';
import tr from './tr/translation';
import nl from './nl/translation';
import ar from './ar/translation';
import ku from './ku/translation';

export default {
  en: {
    translation: en,
  },
  tr: {
    translation: tr,
  },
  nl: {
    translation: nl,
  },
  ar: {
    translation: ar,
  },
  ku: {
    translation: ku,
  },
};
